const ENTITY_NAME = "Feature progression";
const PAGE_TITLES = {
  create: `Create a feature progression`,
  view: `View feature progression`,
  list: `Manage feature progression`
};
const reduxActionTypePrefix = `sample-app-module`;
const ALERT_LABELS = {
  view: "View experiment alerts",
  reload: "Reload alerts",
  loading: "Loading alerts"
};
const PIVOT_KEYS = {
  alerts: "alerts"
};
const DefaultTreatmentVariableNamespace = "default";
const RE_RANDOMIZE_USERS_LINK = "https://aka.ms/exp/docs/usercontrolledresalt";
const IS_SHADOW_EXPERIMENT = "IsShadowExperiment";
export {
  ALERT_LABELS,
  DefaultTreatmentVariableNamespace,
  ENTITY_NAME,
  IS_SHADOW_EXPERIMENT,
  PAGE_TITLES,
  PIVOT_KEYS,
  RE_RANDOMIZE_USERS_LINK,
  reduxActionTypePrefix
};
//# sourceMappingURL=module.constants.js.map
